import React, { useEffect, useRef, useState } from 'react'

const ENCOURAGEMENTS = [
  "Bravo, tu fais ça très bien !",
  "Excellent, reste concentré...",
  "C'est super, tu es vraiment fort !",
  "Continue, tu y arrives très bien !",
  "Magnifique, ton corps te remercie !",
]
const ENCOURAGEMENTS_FIN = [
  "Ton cerveau est maintenant bien oxygéné !",
  "Tu viens de faire quelque chose de fantastique !",
  "Tu as fait preuve d'une belle concentration !",
]

export default function Respiration({ enfantId, configPts = 2 }) {
  const canvasRef = useRef(null)
  // mode: 'idle' | 'running' | 'paused' | 'done'
  const [mode, setMode] = useState('idle')
  const [phase, setPhase] = useState('inhale')
  const [timer, setTimer] = useState(5)
  const [duree, setDuree] = useState(5)
  const [exercice, setExercice] = useState('classic') // 'classic' (5/5) | 'calm' (4/6)
  const [encouragement, setEncouragement] = useState('')
  const [showFireworks, setShowFireworks] = useState(false)
  const [finMsg] = useState(() => ENCOURAGEMENTS_FIN[Math.floor(Math.random() * ENCOURAGEMENTS_FIN.length)])

  // Timings selon exercice
  const INHALE_MS = exercice === 'calm' ? 4000 : 5000
  const EXHALE_MS = exercice === 'calm' ? 6000 : 5000

  // Toutes les variables de contrôle dans un seul ref
  const ctrl = useRef({
    mode: 'idle',
    phase: 'inhale',
    cycles: 0,
    maxCycles: 30,
    phaseStart: 0,
    prog: 0,
    animT: 0,
    encIndex: 0,
    raf: null,
    INHALE_MS: 5000,
    EXHALE_MS: 5000,
  })

  // Sync mode dans ctrl immédiatement
  const setModeSync = (m) => {
    ctrl.current.mode = m
    setMode(m)
  }

  useEffect(() => {
    const canvas = canvasRef.current
    const ctx = canvas.getContext('2d')
    const W = 260, H = 320, CX = 130

    function draw() {
      const c = ctrl.current
      ctx.clearRect(0, 0, W, H)
      ctx.fillStyle = '#0d1b35'
      ctx.fillRect(0, 0, W, H)
      const bg = ctx.createRadialGradient(CX, 200, 0, CX, 200, 200)
      bg.addColorStop(0, 'rgba(37,99,235,0.12)')
      bg.addColorStop(1, 'transparent')
      ctx.fillStyle = bg; ctx.fillRect(0, 0, W, H)

      const cy = 248
      let fH
      if (c.mode === 'idle' || c.mode === 'done') {
        fH = 75 + Math.sin(c.animT * 1.1) * 8
      } else if (c.phase === 'inhale') {
        fH = 15 + c.prog * 195
      } else {
        fH = 210 - c.prog * 200
      }
      fH = Math.max(fH, 7)
      const fW = fH * 0.22
      const sw = Math.sin(c.animT * 2.5) * 3
      const fx = CX + sw, fy = cy - 12, tipY = fy - fH

      const hr = 45 + fH * 0.42
      const hc = c.phase === 'inhale'
        ? `rgba(140,200,255,${0.05 + c.prog * 0.08})`
        : `rgba(255,130,20,${0.06 + c.prog * 0.09})`
      const hg = ctx.createRadialGradient(fx, fy - fH*0.5, 0, fx, fy - fH*0.5, hr)
      hg.addColorStop(0, hc); hg.addColorStop(1, 'transparent')
      ctx.beginPath(); ctx.arc(fx, fy-fH*0.5, hr, 0, Math.PI*2)
      ctx.fillStyle = hg; ctx.fill()

      const fg = ctx.createLinearGradient(fx, fy, fx, tipY)
      fg.addColorStop(0, 'rgba(255,235,55,1)')
      fg.addColorStop(0.28, 'rgba(255,110,8,0.95)')
      fg.addColorStop(0.7, 'rgba(190,25,4,0.72)')
      fg.addColorStop(1, 'transparent')
      ctx.beginPath(); ctx.moveTo(fx, fy)
      ctx.bezierCurveTo(fx+fW, fy-fH*0.25, fx+fW*1.15, fy-fH*0.65, fx, tipY)
      ctx.bezierCurveTo(fx-fW*1.15, fy-fH*0.65, fx-fW, fy-fH*0.25, fx, fy)
      ctx.fillStyle = fg; ctx.fill()

      if (fH > 16) {
        const iw = fW*0.45
        const ig = ctx.createLinearGradient(fx, fy, fx, fy-fH*0.7)
        ig.addColorStop(0, 'rgba(255,255,210,1)')
        ig.addColorStop(0.45, 'rgba(255,215,55,0.8)')
        ig.addColorStop(1, 'transparent')
        ctx.beginPath(); ctx.moveTo(fx, fy)
        ctx.bezierCurveTo(fx+iw, fy-fH*0.18, fx+iw*1.05, fy-fH*0.46, fx, fy-fH*0.72)
        ctx.bezierCurveTo(fx-iw*1.05, fy-fH*0.46, fx-iw, fy-fH*0.18, fx, fy)
        ctx.fillStyle = ig; ctx.fill()
      }

      ctx.strokeStyle = '#180800'; ctx.lineWidth = 3
      ctx.beginPath(); ctx.moveTo(CX, cy-10); ctx.lineTo(CX, cy+10); ctx.stroke()
      const cg = ctx.createLinearGradient(CX-24, 0, CX+24, 0)
      cg.addColorStop(0,'#afa880'); cg.addColorStop(0.3,'#ede3c5')
      cg.addColorStop(0.7,'#ede3c5'); cg.addColorStop(1,'#887848')
      ctx.fillStyle = cg
      ctx.beginPath(); ctx.roundRect(CX-24, cy+8, 48, 68, [4,4,10,10]); ctx.fill()
      ctx.strokeStyle = 'rgba(110,90,50,0.25)'; ctx.lineWidth = 1; ctx.stroke()
      ctx.strokeStyle = 'rgba(190,175,140,0.2)'; ctx.lineWidth = 1
      ;[cy+24, cy+40, cy+56].forEach(yy => {
        ctx.beginPath(); ctx.moveTo(CX-24, yy); ctx.lineTo(CX+24, yy); ctx.stroke()
      })
      ctx.fillStyle = 'rgba(230,218,192,0.6)'
      ctx.beginPath(); ctx.ellipse(CX-9, cy+10, 6, 11, -0.3, 0, Math.PI*2); ctx.fill()
    }

    function loop(now) {
      const c = ctrl.current
      c.animT = now * 0.001

      if (c.mode === 'running') {
        const phaseMs = c.phase === 'inhale' ? c.INHALE_MS : c.EXHALE_MS
        const elapsed = now - c.phaseStart
        c.prog = Math.min(elapsed / phaseMs, 1)
        const secsLeft = Math.max(0, Math.ceil((phaseMs - elapsed) / 1000))
        setTimer(secsLeft)

        if (c.prog >= 1) {
          if (c.phase === 'inhale') {
            c.phase = 'exhale'
            setPhase('exhale')
          } else {
            c.phase = 'inhale'
            c.cycles++
            // Encouragement toutes les 6 cycles (~1 min)
            if (c.cycles > 0 && c.cycles % 6 === 0 && c.cycles < c.maxCycles) {
              const enc = ENCOURAGEMENTS[c.encIndex % ENCOURAGEMENTS.length]
              c.encIndex++
              setEncouragement(enc)
              setTimeout(() => setEncouragement(''), 3000)
            }
            if (c.cycles >= c.maxCycles) {
              c.mode = 'done'
              setModeSync('done')
              setPhase('inhale')
              setTimer(5)
              setShowFireworks(true)
              setTimeout(() => setShowFireworks(false), 4000)
              // Sauvegarder la séance dans localStorage pour les tendances
              if (enfantId) {
                const today = ['Dim','Lun','Mar','Mer','Jeu','Ven','Sam'][new Date().getDay()]
                const semaine = new Date()
                const day = semaine.getDay()
                semaine.setDate(semaine.getDate() - ((day + 6) % 7))
                const semaineStr = semaine.toISOString().split('T')[0]
                const key = `resp_done_${enfantId}_${semaineStr}_${today}`
                const current = parseInt(localStorage.getItem(key) || '0')
                localStorage.setItem(key, String(current + 1))
              }
            } else {
              setPhase('inhale')
            }
          }
          c.phaseStart = now
          c.prog = 0
        }
      }

      draw()
      c.raf = requestAnimationFrame(loop)
    }

    ctrl.current.raf = requestAnimationFrame(loop)
    return () => { if (ctrl.current.raf) cancelAnimationFrame(ctrl.current.raf) }
  }, [])

  const commencer = () => {
    const c = ctrl.current
    const max = duree === 3 ? (exercice === 'calm' ? 18 : 18) : (exercice === 'calm' ? 30 : 30)
    c.mode = 'running'
    c.phase = 'inhale'
    c.cycles = 0
    c.maxCycles = max
    c.phaseStart = performance.now()
    c.prog = 0
    c.encIndex = 0
    c.INHALE_MS = exercice === 'calm' ? 4000 : 5000
    c.EXHALE_MS = exercice === 'calm' ? 6000 : 5000
    setMode('running')
    setPhase('inhale')
    setTimer(exercice === 'calm' ? 4 : 5)
    setEncouragement('')
    setShowFireworks(false)
  }

  const pause = () => {
    ctrl.current.mode = 'paused'
    setMode('paused')
  }

  const reprendre = () => {
    const c = ctrl.current
    c.mode = 'running'
    const phaseMs = c.phase === 'inhale' ? c.INHALE_MS : c.EXHALE_MS
    c.phaseStart = performance.now() - c.prog * phaseMs
    setMode('running')
  }

  const recommencer = () => {
    const c = ctrl.current
    c.mode = 'idle'
    c.phase = 'inhale'
    c.cycles = 0
    c.prog = 0
    c.encIndex = 0
    setMode('idle')
    setPhase('inhale')
    setTimer(5)
    setEncouragement('')
    setShowFireworks(false)
  }

  const totalCycles = duree === 3 ? 18 : 30
  const pctGlobal = mode === 'running' || mode === 'paused'
    ? Math.round((ctrl.current.cycles / totalCycles) * 100)
    : 0

  return (
    <div style={{ display:'flex', flexDirection:'column', alignItems:'center', gap:12, padding:'20px 16px', background:'#0d1b35', borderRadius:16 }}>

      <div style={{ textAlign:'center' }}>
        <h2 style={{ fontFamily:"'Playfair Display',serif", color:'#fff', fontSize:20, margin:0, fontWeight:700 }}>
          {exercice === 'calm' ? 'Calm Express' : 'Cohérence cardiaque'}
        </h2>
        <p style={{ color:'rgba(255,255,255,0.3)', fontSize:11, marginTop:4 }}>
          {exercice === 'calm' ? '4 secondes d\'inspiration · 6 secondes d\'expiration' : '5 secondes · 5 secondes'}
        </p>
      </div>

      {/* Consignes fixes */}
      <div style={{ display:'flex', gap:10, width:'100%', maxWidth:280 }}>
        <div style={{ flex:1, background: phase==='inhale' && mode==='running' ? 'rgba(147,197,253,0.12)' : 'rgba(255,255,255,0.04)', borderRadius:8, padding:'8px 10px', border: phase==='inhale' && mode==='running' ? '1px solid rgba(147,197,253,0.35)' : '1px solid rgba(255,255,255,0.07)', transition:'all 0.6s' }}>
          <div style={{ fontSize:10, fontWeight:700, color:'#93c5fd', marginBottom:3, textTransform:'uppercase', letterSpacing:'0.05em' }}>Inspiration</div>
          <div style={{ fontSize:11, color:'rgba(255,255,255,0.45)', lineHeight:1.4 }}>Inspire doucement comme pour sentir l'odeur de la bougie</div>
        </div>
        <div style={{ flex:1, background: phase==='exhale' && mode==='running' ? 'rgba(251,191,36,0.1)' : 'rgba(255,255,255,0.04)', borderRadius:8, padding:'8px 10px', border: phase==='exhale' && mode==='running' ? '1px solid rgba(251,191,36,0.35)' : '1px solid rgba(255,255,255,0.07)', transition:'all 0.6s' }}>
          <div style={{ fontSize:10, fontWeight:700, color:'#fbbf24', marginBottom:3, textTransform:'uppercase', letterSpacing:'0.05em' }}>Expiration</div>
          <div style={{ fontSize:11, color:'rgba(255,255,255,0.45)', lineHeight:1.4 }}>Expire pour faire bouger la flamme sans l'éteindre</div>
        </div>
      </div>

      {/* Sélecteur exercice + durée — seulement en idle */}
      {mode === 'idle' && (
        <div style={{ display:'flex', flexDirection:'column', alignItems:'center', gap:8, width:'100%', maxWidth:280 }}>
          {/* Choix exercice */}
          <div style={{ display:'flex', gap:8, width:'100%' }}>
            <button onClick={() => setExercice('classic')} style={{ flex:1, padding:'8px 10px', borderRadius:10, border: exercice==='classic' ? 'none' : '1px solid rgba(255,255,255,0.15)', background: exercice==='classic' ? '#2563eb' : 'rgba(255,255,255,0.05)', color:'#fff', cursor:'pointer', fontFamily:"'Inter',sans-serif" }}>
              <div style={{ fontSize:12, fontWeight:700 }}>Cohérence</div>
              <div style={{ fontSize:10, opacity:0.7, marginTop:2 }}>5s / 5s</div>
            </button>
            <button onClick={() => setExercice('calm')} style={{ flex:1, padding:'8px 10px', borderRadius:10, border: exercice==='calm' ? 'none' : '1px solid rgba(255,255,255,0.15)', background: exercice==='calm' ? '#7c3aed' : 'rgba(255,255,255,0.05)', color:'#fff', cursor:'pointer', fontFamily:"'Inter',sans-serif" }}>
              <div style={{ fontSize:12, fontWeight:700 }}>Calm Express</div>
              <div style={{ fontSize:10, opacity:0.7, marginTop:2 }}>4s inspi / 6s expir</div>
            </button>
          </div>
          {/* Durée */}
          <div style={{ display:'flex', background:'rgba(255,255,255,0.06)', borderRadius:20, padding:3, gap:3 }}>
            {[3, 5].map(d => (
              <button key={d} onClick={() => setDuree(d)} style={{ padding:'5px 18px', borderRadius:17, border:'none', background: duree===d ? (exercice==='calm' ? '#7c3aed' : '#2563eb') : 'transparent', color:'#fff', fontSize:12, fontWeight:600, cursor:'pointer', fontFamily:"'Inter',sans-serif" }}>{d} min</button>
            ))}
          </div>
        </div>
      )}

      {/* Encouragement — ENTRE la flamme et le timer */}
      {encouragement && (
        <div className="fade-in" style={{ background:'rgba(37,99,235,0.9)', borderRadius:20, padding:'8px 18px', color:'#fff', fontSize:13, fontWeight:600, textAlign:'center', boxShadow:'0 4px 20px rgba(37,99,235,0.5)', maxWidth:240 }}>
          {encouragement}
        </div>
      )}

      {/* Timer */}
      <div style={{ fontSize:52, fontWeight:800, color: phase==='inhale' ? '#93c5fd' : phase==='exhale' ? '#fbbf24' : 'rgba(255,255,255,0.15)', lineHeight:1, fontFamily:"'Inter',sans-serif", minHeight:60, textAlign:'center', transition:'color 0.5s' }}>
        {mode === 'running' || mode === 'paused' ? timer : '·'}
      </div>

      {/* Canvas */}
      <canvas ref={canvasRef} width={260} height={320} style={{ display:'block', borderRadius:8 }} />

      {/* Barre progression */}
      {(mode === 'running' || mode === 'paused') && (
        <div style={{ width:'100%', maxWidth:240 }}>
          <div style={{ display:'flex', justifyContent:'space-between', marginBottom:4 }}>
            <span style={{ fontSize:11, color:'rgba(255,255,255,0.25)' }}>Progression</span>
            <span style={{ fontSize:11, color:'rgba(255,255,255,0.25)' }}>{duree} min</span>
          </div>
          <div style={{ height:3, background:'rgba(255,255,255,0.08)', borderRadius:2 }}>
            <div style={{ height:'100%', width:`${pctGlobal}%`, background:'#2563eb', borderRadius:2, transition:'width 1s' }} />
          </div>
        </div>
      )}

      {/* Boutons — un seul affiché selon mode */}
      {mode === 'idle' && (
        <button onClick={commencer} style={btnStyle('#2563eb')}>Commencer</button>
      )}
      {mode === 'running' && (
        <button onClick={pause} style={btnStyle('rgba(255,255,255,0.1)', '1px solid rgba(255,255,255,0.2)')}>Pause</button>
      )}
      {mode === 'paused' && (
        <button onClick={reprendre} style={btnStyle('#2563eb')}>Reprendre</button>
      )}
      {mode === 'done' && (
        <button onClick={recommencer} style={btnStyle('#16a34a')}>Recommencer</button>
      )}

      {/* Succès */}
      {mode === 'done' && (
        <div style={{ textAlign:'center', width:'100%' }}>
          {showFireworks && (
            <div className="fade-in" style={{ fontSize:32, letterSpacing:8, marginBottom:10 }}>🎆 🎇 🎆</div>
          )}
          <div style={{ color:'rgba(134,239,172,0.95)', padding:'14px 20px', background:'rgba(22,163,74,0.15)', border:'1px solid rgba(22,163,74,0.3)', borderRadius:12, lineHeight:1.7 }}>
            <div style={{ fontSize:20, fontWeight:800, marginBottom:6 }}>Bravo, tu as réussi !</div>
            <div style={{ fontSize:13, opacity:0.8 }}>{finMsg}</div>
            <div style={{ fontSize:13, marginTop:6, color:'rgba(134,239,172,0.6)' }}>+{configPts} étoiles gagnées</div>
            <button onClick={async () => {
              const jour = new Date().toLocaleDateString('fr-FR', { weekday: 'short' }).replace('.','')
              const jourMap = { lun:'Lun', mar:'Mar', mer:'Mer', jeu:'Jeu', ven:'Ven', sam:'Sam', dim:'Dim' }
              const jourKey = jourMap[jour.toLowerCase()] || jour
              const semaine = new Date()
              const day = semaine.getDay()
              const diff = semaine.getDate() - day + (day === 0 ? -6 : 1)
              semaine.setDate(diff)
              const semaineStr = semaine.toISOString().split('T')[0]
              const key = 'resp_done_' + enfantId + '_' + semaineStr + '_' + jourKey
              const current = parseInt(localStorage.getItem(key) || '0')
              localStorage.setItem(key, current + 1)
              alert('Points ajoutés à ton tableau !')
              if (onPointsAjoutes) onPointsAjoutes()
            }} style={{ marginTop:12, padding:'10px 24px', borderRadius:20, border:'none', background:'#2563eb', color:'#fff', fontWeight:700, fontSize:13, cursor:'pointer', fontFamily:"'Inter',sans-serif", width:'100%' }}>
              ⭐ Ajouter {configPts} points à mon tableau
            </button>
          </div>
        </div>
      )}
    </div>
  )
}

const btnStyle = (bg, border = 'none') => ({
  padding:'11px 0', borderRadius:24, border,
  background: bg, color:'#fff', fontSize:14, fontWeight:600,
  cursor:'pointer', width:200, fontFamily:"'Inter',sans-serif"
})
